module.exports = __webpack_public_path__ + "static/media/mail-icon.3d3214b5.svg";